<template>
  <el-tooltip
    :content="translatedLabel"
    placement="bottom"
    :disabled="!label || !isCollapsed"
    popper-class="sidebar-item-tooltip__popper"
  >
    <div class="tooltip-trigger">
      <span v-if="icon" class="prefix-icon--off">
        <svg-icon class="sidebar-item-icon" :icon-class="icon" />
      </span>
      <span v-if="iconActive" class="prefix-icon--on">
        <svg-icon class="sidebar-item-icon" :icon-class="iconActive" />
      </span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'SidebarItemTooltip',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTooltipLabel: null,
    }
  },
  computed: {
    label() {
      return this.item?.meta?.label ?? ''
    },
    translatedLabel() {
      return this.$te(this.label) ? this.$t(this.label) : ''
    },
    icon() {
      return this.item?.meta?.icon ?? this.item?.parent?.meta?.icon ?? ''
    },
    iconActive() {
      return (
        this.item?.meta?.iconActive ?? this.item?.parent?.meta?.iconActive ?? ''
      )
    },
  },
  methods: {
    showTooltip(label) {
      this.activeTooltipLabel = label
    },
    hideTooltip() {
      this.activeTooltipLabel = null
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar-item-icon {
  font-size: 20px;
}
</style>
